import me from "./../../assets/me.png";

export const HomeTab = () => (
  <div className="flex-grow px-4 py-5 sm:p-6 overflow-y-scroll flex flex-row">
    <div className="flex-grow">
      <h1 className="text-gray-700 text-2xl font-bold p-2">
        Hi there, I'm Luca :)
      </h1>
      <h2 className="text-gray-700 text-xl p-2">
        I'm a third-year at the University of Chicago majoring in Computer
        Science. I interned at SpaceX this winter, and I'm excited to be
        interning with Citadel Securities this summer.
      </h2>
      <img
        src={me}
        className="w-auto mx-auto sm:w-0 h-48 py-2 rounded-[2rem]"
      />
    </div>
    <img
      src={me}
      className="sm:inline-block hidden sm:w-auto h-64 p-8 rounded-[4rem]"
    />
  </div>
);
